module.exports = __webpack_public_path__ + "media/images/pic/certificates/forbes-2022-aaada130bb51592bf8014352dcfe4192.png";